import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const NotFound = () => {
    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
            <div className="text-center p-5 bg-white rounded shadow-sm border">
                <div className="display-1 fw-bold text-primary mb-3">404</div>
                <h2 className="mb-3">Bogga Lama Helin</h2>
                <p className="text-muted mb-4 lead">
                    Cilad! Bogga aad raadineyso ma jiro ama waa la raray.
                </p>
                <Link to="/dashboard" className="btn btn-primary px-4 py-2 rounded-pill">
                    Ku Laabo Muuraayada
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
